import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTranslation} from "react-i18next"
import useTeam from "../../swrCustomHooks/useTeam"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import TeamUserCard from "../../components/team-user-card/TeamUserCard"
import AddTeamUsersForm from "../../forms/team-users/AddTeamUsersForm"

export default function TeamManagementContent() {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {team, mutateTeam, isLoadingTeam, isErrorTeam} = useTeam(sessionContext.idTeam)

    if (isErrorTeam || isLoadingTeam || team.message || !team.team || !team.users) return <LoadingComponent/>
    return (
        <>
        <div className="SECTION TEAM-MANAGEMENT-CONTENT">
            <h2>{t("Add a member")}</h2>
            <AddTeamUsersForm mutateTeam={mutateTeam}/>
            <h2>{`${t("Team members")} - ${team.team.name}`}</h2>
            <span>{team.users.length} {t("creators")}/ {team.team.max_users} {t("creators")}</span>
            <div className="users">
                {team.users.map((user, index) => (
                    <TeamUserCard key={`user-${index}`} user={user} idAdmin={team.team.id_admin} type={"team-management"}/>
                ))}
            </div>
        </div>
        </>
    )
}